module.exports = __webpack_public_path__ + "img/channels.503d75a7.svg";